import { useState } from 'react';
import { Container, Tabs, Tab } from 'react-bootstrap';
import ProcessMapsPanel from '../components/process_maps/ProcessMapsPanel';
import ProcessMapUploadPanel from '../components/process_maps/ProcessMapUploadPanel';

const AdminProcessMaps = () => {
  const [key, setKey] = useState<string>('maps');

  return (
    <Container className="mt-4">
      <h2>Process Map Administration</h2>
      <Tabs activeKey={key} onSelect={(k) => setKey(k || 'maps')} className="mb-3">
        <Tab eventKey="maps" title="Process Maps">
          <ProcessMapsPanel />
        </Tab>
        <Tab eventKey="mapupload" title="Process Map Upload">
          <ProcessMapUploadPanel loadMaps={() => { 
            ProcessMapsPanel.prototype.loadMaps(); //
            /* TODO: implement loadMaps logic */ }} />
        </Tab>
      </Tabs>
    </Container>
  );
};

export default AdminProcessMaps;
